export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    setEmployabilityFormOpen({commit}) {
        commit('setEmployabilityFormOpen');
    },
    setOpinionFormOpen({commit}) {
        commit('setOpinionFormOpen');
    }
}
